<template>
  <div v-if="ready">
    <v-row>
      <v-col>
        <v-card flat>
          <v-card-title>
            {{ __("Código") }}: {{ subtype_id }}
            <v-spacer />
            <v-btn
              :to="{ name: 'requested-documents-types-subtypes' }"
              exact
              icon
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat>
          <v-card-title>
            {{ __("Categorias") }}
            <v-btn
              @click="$refs.category_form.open()"
              color="primary"
              outlined
              class="ml-4"
              small
            >
              <v-icon left>mdi-plus</v-icon> {{ __("Cadastrar") }}
            </v-btn>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="categories"
            item-value="id"
            hide-default-footer
            height="calc(100vh - 360px)"
            fixed-header
            :items-per-page="-1"
            @click:row="handleRowClick"
          >
            <template v-slot:item.action="{ item }">
              <v-btn @click.stop="handleDeleteCategory(item)" icon>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogs -->
    <RequestedDocumentTypeFormDialog
      ref="category_form"
      @add="handleAddCategory"
      @update="handleUpdateCategory"
    />
    <ConfirmationDialog ref="confirmation" />
  </div>
</template>

<script>
import QueryMixin from "@/mixins/QueryMixin.vue";
import ToastsMixin from "@/mixins/ToastsMixin";
import i18n from "@/mixins/i18n";

import RequestedDocumentTypeFormDialog from "@/components/RequestedDocumentsTypes/RequestedDocumentTypeFormDialog.vue";
import ConfirmationDialog from "@/components/tools/ConfirmationDialog.vue";

import {
  listRequestedDocumentTypes,
  createRequestedDocumentType,
  updateRequestedDocumentType,
  deleteRequestedDocumentType,
} from "@/services/requested_documents_types";

export default {
  mixins: [QueryMixin, ToastsMixin, i18n],

  components: {
    RequestedDocumentTypeFormDialog,
    ConfirmationDialog,
  },

  props: {
    subtype_id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      i18n_prefix: "requested_documents",
      ready: false,
      categories: [],
      headers: [
        { text: "Cód.", value: "id", width: 100 },
        { text: this.__("Nome", "settings"), value: "name" },
        {
          text: this.__("ações", "settings"),
          value: "action",
          sortable: false,
          width: 150,
        },
      ],
    };
  },

  methods: {
    async getQuery() {
      const lead_type_id = this.$route.params.lead_type_id;
      const response = await listRequestedDocumentTypes(
        lead_type_id,
        this.subtype_id
      );
      this.categories = response.data;
      return response.data;
    },

    async handleAddCategory(form) {
      try {
        const lead_type_id = this.$route.params.lead_type_id;
        const newCategory = await createRequestedDocumentType(
          lead_type_id,
          this.subtype_id,
          form.name
        );

        this.categories.push(newCategory);

        this.toastSuccess(
          this.__("Categoria adicionada com sucesso", "settings")
        );
      } catch (e) {
        console.error(e);
        this.toastError(this.__("Erro ao adicionar categoria", "settings"));
      }
    },

    handleRowClick(item) {
      this.$refs.category_form.open(item);
    },

    async handleUpdateCategory(form) {
      try {
        await updateRequestedDocumentType(form.id, form.name);

        const index = this.categories.findIndex(
          (category) => category.id === form.id
        );
        if (index !== -1) {
          this.$set(this.categories, index, {
            ...this.categories[index],
            name: form.name,
          });
        }

        this.toastSuccess(
          this.__("Categoria atualizada com sucesso", "settings")
        );
      } catch (e) {
        console.error(e);
        this.toastError(this.__("Erro ao atualizar categoria", "settings"));
      }
    },

    async handleDeleteCategory(category) {
      this.$refs.confirmation.confirm(
        this.__("Deseja realmente excluir a categoria?", "settings"),
        async ({ close, startLoading, stopLoading }) => {
          startLoading();

          try {
            await deleteRequestedDocumentType(category.id);

            this.categories = this.categories.filter(
              (c) => c.id !== category.id
            );

            this.toastSuccess(
              this.__("Categoria removida com sucesso", "settings")
            );

            close();
          } catch (error) {
            console.error(error);
            this.toastError(this.__("Erro ao remover categoria", "settings"));
          } finally {
            stopLoading();
          }
        },
        null,
        {
          confirmText: this.__("excluir", "settings"),
          cancelText: this.__("cancelar", "settings"),
          color: "error",
          description: this.__(
            "Documentos solicitados vinculados a este tipo podem não ser mais exibidos corretamente",
            "settings"
          ),
        }
      );
    },
  },

  watch: {
    $route() {
      this.refresh();
    },
  },

  created() {
    this.refresh();
  },
};
</script>
